import * as _ from 'lodash';
import { useCallback, type VoidFunctionComponent } from 'react';

import ModalStreamBuild from '../../../modals/ModalStreamBuild';

type Props = {
  buildId: number | null;
  setBuildId: (buildId: number | null) => void;
};

const StreamBuild: VoidFunctionComponent<Props> = ({ buildId, setBuildId }) => {
  const onClose = useCallback(() => {
    // Reset the build id to hide the modal
    setBuildId(null);
  }, [setBuildId]);

  if (!buildId) {
    return null;
  }

  return (
    <ModalStreamBuild
      buildId={buildId}
      show={_.isNil(buildId)}
      onHide={onClose}
      isProjectLocator={false}
    />
  );
};

export default StreamBuild;
